var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"type":"datetime-local"},model:{value:(_vm.local),callback:function ($$v) {_vm.local=$$v},expression:"local"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }